export default __webpack_public_path__ + "static/media/play.e3891b05.svg";